import { Results } from './pagination'

export const CREATED = 'OP_CREATED'
export const RUNNING = 'OP_RUNNING'
export const DONE = 'OP_DONE'
export const STOPPING = 'OP_STOPPING'
export const ABORTED = 'OP_ABORTED'
export const FAILED = 'OP_FAILED'

export type OptimizationProcessStatus =
  | typeof CREATED
  | typeof RUNNING
  | typeof DONE
  | typeof ABORTED
  | typeof STOPPING
  | typeof FAILED

export type OptimizationProcess = {
  id: number
  dataIngestion: number
  status: OptimizationProcessStatus
  createdAt: Date
  startedAt?: Date
  stoppedAt?: Date
  planningStart: Date
  planningEnd: Date
  optimizationProcessType?: string
  sync?: Date
  version?: string
  user?: string
  referenceOptimizationProcess?: number
  name?: string
  notes?: string
  official?: boolean
}

export type OptimizationProcesses = Results<OptimizationProcess>

export const isCreated = (
  status: OptimizationProcessStatus
): status is typeof CREATED => status === CREATED

export const isRunning = (
  status: OptimizationProcessStatus
): status is typeof RUNNING => status === RUNNING

export const isDone = (
  status: OptimizationProcessStatus
): status is typeof DONE => status === DONE

export const isAborted = (
  status: OptimizationProcessStatus
): status is typeof ABORTED => status === ABORTED

export const isFailed = (
  status: OptimizationProcessStatus
): status is typeof FAILED => status === FAILED

export const isStopping = (
  status: OptimizationProcessStatus
): status is typeof STOPPING => status === STOPPING
